import { render, staticRenderFns } from "./crear-colaborador-editar.vue?vue&type=template&id=5d865055&scoped=true&"
import script from "./crear-colaborador-editar.vue?vue&type=script&lang=js&"
export * from "./crear-colaborador-editar.vue?vue&type=script&lang=js&"
import style0 from "./crear-colaborador-editar.vue?vue&type=style&index=0&id=5d865055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d865055",
  null
  
)

export default component.exports